<div class="vertical-slider">
  <svg></svg>
  <div [attr.id]="settings['id']"></div>
  <div *ngFor="let handle of handles | keyvalue" class="input" [ngStyle]="handle.value.style">
    <input
      autocomplete="off"
      type="number"
      step="{{step}}"
      [(ngModel)]="handle.value.value"
      (ngModelChange)="positiveNumbers($event,handle)"
      (blur)="handle.value.updateHandle(minStep)"
      disabled="{{readOnly}}"
    />
    {{options.unit}}
  </div>
</div>
